import { HELP_BOT_URL } from '@/config'

export const HELP_BOT_API = `${HELP_BOT_URL}/api/help-bot`
export const HELP_ARTICLES_API = `${HELP_BOT_URL}/api/help-articles`
